<p-tabView>
  <p-tabPanel header="Plantilla">
    <!--<div *ngIf="template.id == null && false">
      <p-card header="Datos generales">
          <div class="p-grid">
              <div class="p-col-12 p-field">
                  <label for="name">Nombreeee</label>
                  <input name="name" type="text" pInputText [(ngModel)]="template.name" />
              </div>
              <div class="p-col-6 p-field">
                  <label for="template_type">Tipo de datossss</label>
                  <p-dropdown name="template_type" [(ngModel)]="template.template_type_id" [options]="templateTypes" optionLabel="name" optionValue="id" appendTo="body"></p-dropdown>
              </div>
              <div class="p-col-6 p-field">
                  <label for="entity">Tipo de datossss</label>
                  <p-dropdown name="entity" [(ngModel)]="template.entity_id" [options]="entities" optionLabel="name" optionValue="id" appendTo="body"></p-dropdown>
              </div>
          </div>
      </p-card>
  </div>-->
    <app-view #view [code]="'templates.new'" [model]="template" (onEvent)="onEvent($event)" *ngIf="template.id == null"></app-view>
    <app-view #view [code]="'templates.edit'" [model]="template" (onEvent)="onEvent($event)" *ngIf="template.id != null"></app-view>
  </p-tabPanel>
    <p-tabPanel header="Permisos">
        <p-accordion>
            <p-accordionTab header="Zonas" *ngIf="zonesPermission">
                <div class="p-grid">
                    <div class="p-col-12 p-field">
                        <p-dropdown appendTo="body" [options]="zones" [(ngModel)]="selected_zone" optionLabel="name"
                            placeholder="Selecciona una zona." (onChange)="save_zone()" [disabled]="zones.length == 0">
                        </p-dropdown>
                    </div>
                    <!--
                    <div class="p-col-2 p-field">
                        <button pButton class="p-button-primary" label="Añadir zona"></button>
                    </div>
                    -->
                    <div class="p-col-12">
                        <p-table #grid [value]="selected_zones">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th width="100">ID</th>
                                    <th>Nombre</th>
                                    <th width="100"></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-zone>
                                <tr>
                                    <td>{{zone.id}}</td>
                                    <td>{{zone.name}}</td>
                                    <td class="grid-actions">
                                        <a (click)="unlinkZone(zone)" class="color-danger">
                                            <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                                        </a>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td [attr.colspan]="3">
                                        No se encontraron datos
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </p-accordionTab>
            <p-accordionTab header="Roles">
                <div class="p-grid">
                    <div class="p-col-12 p-field">
                        <p-dropdown appendTo="body" [options]="roles" [(ngModel)]="selected_role" optionLabel="name"
                            placeholder="Selecciona un rol." (onChange)="save_role()" [disabled]="roles.length == 0">
                        </p-dropdown>
                    </div>
                    <div class="p-col-12">
                        <p-table #grid [value]="selected_roles">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th width="100">ID</th>
                                    <th>Nombre</th>
                                    <th width="100"></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-role>
                                <tr>
                                    <td>{{role.id}}</td>
                                    <td>{{role.name}}</td>
                                    <td class="grid-actions">
                                        <a (click)="unlinkRole(role)" class="color-danger">
                                            <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                                        </a>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td [attr.colspan]="3">
                                        No se encontraron datos
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </p-accordionTab>
            <p-accordionTab header="Usuarios">
                <div class="p-grid">
                    <div class="p-col-12 p-field">
                        <p-dropdown appendTo="body" [options]="users" [(ngModel)]="selected_user" optionLabel="name"
                            placeholder="Selecciona un usuario." (onChange)="save_user()"
                            [disabled]="users.length == 0">
                        </p-dropdown>
                    </div>
                    <div class="p-col-12">
                        <p-table #grid [value]="selected_users">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th width="100">ID</th>
                                    <th>Nombre</th>
                                    <th>Correo</th>
                                    <th width="100"></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-user>
                                <tr>
                                    <td>{{user.id}}</td>
                                    <td>{{user.name}}</td>
                                    <td>{{user.email}}</td>
                                    <td class="grid-actions">
                                        <a (click)="unlinkUser(user)" class="color-danger">
                                            <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                                        </a>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td [attr.colspan]="4">
                                        No se encontraron datos
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </p-accordionTab>
        </p-accordion>
    </p-tabPanel>
</p-tabView>
